module.exports = __webpack_public_path__ + "static/media/about.f94a693f.jpg";